<div id="allegation-case-main-content" class="row">    
    <div class="col-sm-2">
    <ul id="allegation-table-of-contents-nav-list" class="nav nav-pills nav-stacked">

         <!-- Start Attorney Case Detail -->            
         <li [className]="isSet('RLALLGN')?'inline active':'inline'"><a (click)="setPanelName('RLALLGN')">Related&nbsp;Allegations</a></li>        
        <!-- End Attorney Case Detail -->
      </ul>
    </div>
        
    <div class="col-sm-10">
	        <!-- Begin Related Allegations -->
            <div *ngIf="panelName === 'RLALLGN'" class="panel panel-default page" id="section-related-allegations">
              <div class="panel-collapse collapse in" style="height: auto;">
                <app-related-allegations [additionalInfo]="additionalInfo"></app-related-allegations>
              </div>
              <div class="title-bar">
                <h3 id="RelatedAllegations" class="panel-title summary-label">Related Allegations</h3>
              </div>
            </div>
            <!-- End Related Allegations --> 

      <!-- <div style="height:1000px"></div> -->
    </div>
    </div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/events/events-additional-info/events-additional-info.component.html